import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  useEffect(() => { document.title = "页面不存在 · 漫糖韩漫"; }, []);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <div className="relative z-10">
        <i className="ri-ghost-line text-6xl text-foreground-400"></i>
        <h1 className="text-2xl md:text-3xl font-heading font-semibold mt-6 text-foreground-950">页面跑丢了</h1>
        <p className="mt-4 text-lg md:text-xl text-foreground-600">你要找的页面可能已经下线或者被转移了</p>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50">
          <i className="ri-home-4-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}